// @flow
import type { AxiosInstance, AxiosPromise } from "axios";
import type {
  BookingTransformer,
  ChallengeResponse,
  ThreeDS2Challenge
} from "../types";
import debug from "../helpers/debug";
import commaSeparatedArray from "../helpers/commaSeparatedArray";

const createBooking3DS2Request = (
  paymentId: string,
  quoteId: string,
  payOnArrival: boolean,
  partnerName: string | null,
  threeDS2: ThreeDS2Challenge | null,
  challengeResponse: ChallengeResponse | null
): ((apiInstance: AxiosInstance) => AxiosPromise<BookingTransformer>) => (
  apiInstance
) => {
  debug("checkout.book", {
    payOnArrival,
    threeDS2,
    challengeResponse,
    paymentId,
    quoteId
  });
  const formattedChallengeResponse = challengeResponse
    ? {
        booking_id: challengeResponse.bookingId,
        challenge_session_id: challengeResponse.challengeSessionId,
        cookie: challengeResponse.cookie,
        jwt: challengeResponse.jwt,
        order_id: challengeResponse.orderId,
        raw_payload: challengeResponse.rawPayload,
        transaction_id: challengeResponse.transactionId,
        transaction_token_id: challengeResponse.transactionTokenId
      }
    : null;

  // Pass 3DS challenge response if set, or the initial request data
  const threeDSParams = formattedChallengeResponse || threeDS2;

  const include = [
    "barrier_tokens",
    "listing.address",
    "listing.photos",
    "evses",
    "vehicle",
    "listing",
    "driver",
    "awin",
    "review"
  ];

  return apiInstance.post(
    "/v5/checkout",
    {
      pay_on_arrival: payOnArrival,
      payment_source_id: paymentId,
      quote_id: quoteId,
      ...(partnerName && { partner_name: partnerName }),
      ...threeDSParams
    },
    {
      params: {
        include
      },
      paramsSerializer: commaSeparatedArray
    }
  );
};

export default createBooking3DS2Request;
